import { createContext, useContext } from "react";

// Default context value
const defaultContextValue = {
  tags: [],
  tagTypes: [],
  loading: false,
  error: null,
  dispatch: () => {},
};

export const TagsHierarchyViewerContext = createContext(defaultContextValue);

export const useTagsHierarchyViewer = () => {
  return useContext(TagsHierarchyViewerContext);
};
